import { Component, Input } from "@angular/core";
import { PepDialog } from "./pep-dialog.model";

// @@angularMigrate wrong?
@Component({
    selector: 'pep-message-dialog',
    templateUrl: './pep-message-dialog.component.html',
    standalone: false
})

export class PepMessageDialogComponent extends PepDialog {

    @Input() showCancelButton: boolean = false;
    @Input() acceptButtonText: string;
    @Input() disabled: boolean = false;
}
